import React from 'react'
import PropTypes from 'propTypes'

import { LazyImage, useMediaQuery } from '@offerzen/pinata-shame'

import Container from '../../components/Container'
import MobileNav from '../../components/MobileNav'
import NavMenu from '../../components/NavMenu'
import NavToggle from '../../components/NavToggle'
import { impersonatedHiringTeam } from '../../helpers/companyHelpers'
import styles from './styles'

const Navbar = ({
  match,
  history,
  hiringTeams,
  signOut,
  metadata,
  loadingCompany,
  currentHiringTeam,
  switchHiringTeam,
  userRole,
  emailPreferencesAccessTokenKey,
}) => {
  const { isDesktopOrLarger } = useMediaQuery()

  return (
    <nav id="nav-bar" className={styles.wrapper}>
      <Container className={styles.container}>
        <If condition={!loadingCompany}>
          <a href="/" className={styles.logo}>
            <LazyImage className={styles.logoImage} loader={() => import('../../../assets/offerzen-logo.svg')} />
            <span className={styles.accessiblyHidden}>OfferZen</span>
          </a>

          <Choose>
            <When condition={isDesktopOrLarger}>
              <If condition={hiringTeams.length > 1}>
                <NavToggle
                  activeHiringTeam={currentHiringTeam}
                  hiringTeams={hiringTeams}
                  onItemClick={id => switchHiringTeam(match.params.companySlug, id)}
                />
              </If>

              <NavMenu
                impersonatedHiringTeam={impersonatedHiringTeam(history)}
                userRole={userRole}
                companySlug={match.params.companySlug}
                signOut={signOut}
                emailPreferencesAccessTokenKey={emailPreferencesAccessTokenKey}
                unreadInterviewRequestCount={metadata.unreadInterviewRequestCount}
                companyState={metadata.companyState}
              />
            </When>

            <Otherwise>
              <MobileNav
                userRole={userRole}
                companySlug={match.params.companySlug}
                signOut={signOut}
                emailPreferencesAccessTokenKey={emailPreferencesAccessTokenKey}
                unreadInterviewRequestCount={metadata.unreadInterviewRequestCount}
                companyState={metadata.companyState}
              />
            </Otherwise>
          </Choose>
        </If>
      </Container>
    </nav>
  )
}

Navbar.propTypes = {
  loadingCompany: PropTypes.bool,
  currentHiringTeam: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  hiringTeams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  switchHiringTeam: PropTypes.func,
  userRole: PropTypes.string,
  companySlug: PropTypes.string,
  signOut: PropTypes.func,
  emailPreferencesAccessTokenKey: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      companySlug: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
  }),
  metadata: PropTypes.shape({
    companyStateLabel: PropTypes.string,
    unreadInterviewRequestCount: PropTypes.number,
    companyState: PropTypes.string,
  }),
  companyState: PropTypes.string,
}

export default Navbar
